import React from 'react';
import CreatableInputField from '../../../components/CreatableInputField';
import SearchField from '../../../components/Input/SearchField';
import TextFieldLabel from '../../../components/Input/TextFieldLabel';

const BooleanDetailField = (props) => {
	const { placeholder, label, value, editMode, onChange, labelForFalse, labelForTrue, valueForTrue, valueForFalse } = props;

	const [isTrue, setIsTrue] = React.useState(value === valueForTrue || value === true);

	const updateValue = (newValue) => {
		if (newValue) {
			setIsTrue(true);
			onChange(valueForTrue);
		} else {
			setIsTrue(false);
			onChange(valueForFalse);
		}
	}

	return (
		<div className="detail-field-wrapper">
			{editMode ? (
				<React.Fragment>
					<TextFieldLabel>{label}</TextFieldLabel>
					<div className='portal-access-radio-options mt-xxl'>
                    <TextFieldLabel className='portal-access-radio-label' > {labelForTrue || "Yes"}
                        <input type={"radio"} className='portal-access-radio' checked={isTrue} value={isTrue} name={label} onClick={() => updateValue(true)} />
                    </TextFieldLabel>
                    <TextFieldLabel className='portal-access-radio-label' > {labelForFalse || "No"}
                        <input type={"radio"} className='portal-access-radio' checked={!isTrue} value={!isTrue} name={label} onClick={() => updateValue(false)} />
                    </TextFieldLabel>
                </div>
				</React.Fragment>
			) : (
				<React.Fragment>
					<label className="colour-text-label-grey transition-fade-up">{label}</label>
					<div className={`transition-fade-up-slow`} style={{ wordBreak: "break-word" }}>
					{isTrue ? (labelForTrue || 'Yes') : (labelForFalse || 'No') }
					</div>
				</React.Fragment>
			)}
		</div>
	);
}

export default BooleanDetailField;